import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileConst } from '../utils';
import { RoleGuard } from '../role.guard';


const routes: Routes = [
    {
        path: 'front-counter',
        loadChildren: () => import('./front-counter/front-counter.module').then(m => m.FrontCounterModule),
        data: { expectedRoles: [ProfileConst.front_counter_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'driver-fc-waiting-list',
        loadChildren: () => import('./fc-driver-waiting-list/fc-driver-waiting-list.module').then(m => m.FcDriverWaitingListModule),
        data: { expectedRoles: [ProfileConst.kiosk_waiting_list] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'warehouse',
        loadChildren: () => import('./warehouse/warehouse.module').then(m => m.WarehouseModule),
        data: { expectedRoles: [ProfileConst.warehouse_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'driver-wh-waiting-list',
        loadChildren: () => import('./wh-driver-waiting-list/wh-driver-waiting-list.module').then(m => m.WhDriverWaitingListModule),
        data: { expectedRoles: [ProfileConst.waiting_list_wh_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'warehouse-kiosk',
        loadChildren: () => import('./warehouse-kiosk/warehouse-kiosk.module').then(m => m.WarehouseKioskModule),
        data: { expectedRoles: [ProfileConst.warehouse_driver_checkin_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'kiosk',
        loadChildren: () => import('./kiosk/kiosk.module').then(m => m.KioskModule),
        data: { expectedRoles: [ProfileConst.kiosk_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'back-office-list',
        loadChildren: () => import('./back-office-list/back-office-list.module').then(m => m.BackOfficeListModule),
        data: { expectedRoles: [ProfileConst.back_office_list_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'dock-guard',
        loadChildren: () => import('./dock-guard/dock-guard.module').then(m => m.DockGuardModule),
        data: { expectedRoles: [ProfileConst.dock_guard_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class CargoFacilityRoutingModule { }
